'use client';

import React, { useContext, FC } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { ProductionStatCard } from './ProductionStatCard';
import { RootStoreContext } from '@stores/rootStore';
import { LFNumber } from '@components/LFNumber';
export const ProductionStats: FC<{
  total?: number;
  percentageOfTarget?: number;
  averageYield?: number;
  percentageOfTargetYield?: number;
}> = observer(({
  total,
  percentageOfTarget,
  averageYield,
  percentageOfTargetYield
}) => {
  const {
    userStore
  } = useContext(RootStoreContext);
  const {
    t
  } = useTranslation();
  return <div className={`
        flex h-full flex-col justify-between gap-4 rounded-xl bg-smoke p-12
        print:w-full print:flex-row print:px-20
      `}>
        <div className={`
          w-full
          print:w-1/2
        `}>
          <ProductionStatCard title={t('totalActualProd', {
        unit: t(userStore.user.settings.weight_unit)
      })} printTitle={t('totalProd')} unit={t(userStore.user.settings.weight_unit)} mainValue={<LFNumber num={total!} format="weight" computed />} targetPerc={percentageOfTarget} testId="overview-total-production-stat" />
        </div>
        <div className={`
          w-full
          print:w-1/2
        `}>
          <ProductionStatCard title={t('averageYieldUnit', {
        unit: `${t(userStore.user.settings.weight_unit)}/${t(userStore.user.settings.area_unit)}`
      })} printTitle={t('averageYield')} unit={`${t(userStore.user.settings.weight_unit)}/${t(userStore.user.settings.area_unit)}`} mainValue={<LFNumber num={averageYield} format="yield" computed />} targetPerc={percentageOfTargetYield} />
        </div>
      </div>;
});